import * as api from 'Shared/api';
import { handleError } from 'Shared/helpers';

export const getRecommendationChart = ({ chartCode, timeFilters, userId, tags }) => dispatch => {
  dispatch({
    type: 'CHART_GET_REQUEST',
    chartCode,
  });

  return api.getRecommendationChart({ chartCode, timeFilters, userId, tags }).then(
    response => {
      const json = response.data;

      dispatch({
        type: 'CHART_GET_RESPONSE',
        chartCode,
        payload: json.data,
      });
    },
    error => {
      dispatch(handleError(error));
    }
  );
};
